'use client';

import { useEffect, useState } from 'react';
import HeroSection from './HeroSection';
import ProcessTimeline from './ProcessTimeline';
import PropertySubmissionForm from './PropertySubmissionForm';
import ComparisonChart from './ComparisonChart';
import FAQSection from './FAQSection';

const SellersInteractive = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  if (!isHydrated) {
    return (
      <div className="min-h-screen bg-background">
        <div className="animate-pulse">
          <div className="h-96 bg-muted"></div>
          <div className="max-w-7xl mx-auto px-4 py-16 space-y-8">
            <div className="h-8 bg-muted rounded w-1/2 mx-auto"></div>
            <div className="h-4 bg-muted rounded w-3/4 mx-auto"></div>
            <div className="grid md:grid-cols-2 gap-8">
              <div className="h-64 bg-muted rounded"></div>
              <div className="h-64 bg-muted rounded"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <HeroSection />
      <ProcessTimeline />
      <PropertySubmissionForm />
      <ComparisonChart />
      <FAQSection />
    </div>
  );
};

export default SellersInteractive;
